import { CheckCircle2, AlertCircle, Info } from "lucide-react";
import { motion } from "framer-motion";

export default function Toast({ toast, removeToast }) {
  const icons = {
    success: <CheckCircle2 className="h-6 w-6 text-success-400" aria-hidden="true" />,
    error: <AlertCircle className="h-6 w-6 text-danger-400" aria-hidden="true" />,
    warning: <AlertCircle className="h-6 w-6 text-amber-400" aria-hidden="true" />,
    info: <Info className="h-6 w-6 text-info-400" aria-hidden="true" />
  };

  const titles = {
    success: "Succès",
    error: "Erreur",
    warning: "Attention",
    info: "Information"
  };

  const progressColors = {
    success: "bg-success-500",
    error: "bg-danger-500",
    warning: "bg-amber-500",
    info: "bg-info-500"
  };

  const type = toast.type || "info";

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 50, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
      transition={{ type: "spring", damping: 25, stiffness: 300 }}
      className="pointer-events-auto relative w-full max-w-sm overflow-hidden rounded-lg bg-[var(--hp-color-surface)] shadow-[var(--hp-shadow-lg)] ring-1 ring-black/5"
    >
      <div className="p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            {icons[type]}
          </div>
          <div className="ml-3 w-0 flex-1 pt-0.5">
            <p className="text-sm font-medium text-[var(--hp-color-text)]">{titles[type]}</p>
            <p className="mt-1 text-sm text-[var(--hp-color-text-subtle)]">{toast.message}</p>
          </div>
        </div>
      </div>

      {/* Barre de progression (durée de vie du Toast) */}
      <motion.div
        initial={{ width: "100%" }}
        animate={{ width: "0%" }}
        transition={{ duration: 5, ease: "linear" }}
        className={`absolute bottom-0 left-0 h-1 ${progressColors[type]}`}
      />
    </motion.div>
  );
}
